import Region from "./Region";

class ConservationScore {
  constructor(phylopScore, x0, chr) {
    this.phylopScore = phylopScore === null ? null : Number(phylopScore);
    this.region = new Region(x0, x0 + 1, chr);
  }
}

export default ConservationScore;
